import { createGlobalStyle } from 'styled-components';

import nimbus from '../assets/fonts/nimbus.ttf';
import rift_bold from '../assets/fonts/rift_bold.otf';
import agaramond_italic from '../assets/fonts/agaramond_italic.otf';
import nimbus_bold from '../assets/fonts/nimbus_bold.ttf';
import nimbus_bold_woff from '../assets/fonts/nimbus_bold.woff';

const Typography = createGlobalStyle`
  @font-face {
    font-family: Nimbus;
    src: url(${nimbus});
  }
  @font-face {
    font-family: NimbusBold;
    src: url(${nimbus_bold});
  }
  @font-face {
    font-family: NimbusBoldWoff;
    src: url(${nimbus_bold_woff});
  }
   @font-face {
    font-family: Rift_Bold;
    src: url(${rift_bold});
  }
  @font-face {
    font-family: Agaramond_Italic;
    src: url(${agaramond_italic});
  }
  html {
    font-family: Nimbus, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: var(--black);
    font-size: 7px !important;
  }

  body {
    /* font-size: 1.5rem !important; */
  }

  strong {
    font-family: NimbusBold, NimbusBoldWoff;
    font-weight: 900;
  }

  nav {
      font-family: Nimbus
  }

  p, li {
    font-family: Nimbus;
    letter-spacing: 0.5px;
    margin: 0;
  }
  h1,h2,h3,h4,h5,h6 {
    font-family: Rift_Bold;
    letter-spacing: 0.04em;
    font-weight: normal;
    margin: 0;
  }

  h1 {
    font-size: 5em !important;

    @media (max-width: 768px) {
      font-size: 2em !important;
    }
  }

  h2 {
    font-size: 3em !important;
    @media (max-width: 768px) {
      font-size: 2em !important;
    }
  }

  h3 {
    font-size: 1.5em ;
    line-height: 1.2em;
    text-align: left;
  }

  a {
    color: var(--black);
    text-decoration: none;
  }
  mark, .mark {
    background: var(--yellow);
    padding: 0 2px 2px 2px;
    margin: 0;
    display: inline;
    line-height: 1;
  }
  .center {
    text-align: center;
  }
  .tilt {
    transform: rotate(-2deg);
  }
`;

export default Typography;
